import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  TemplateRef,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { PuebloBase } from '@components/pueblo-base.component';

export interface SimpleDialogButtonConfig {
  type?: 'flat' | 'stroked' | 'raised' | 'default' | 'icon';
  label?: string;
  icon?: string;
  error?: boolean;
  close?: boolean;
  back?: boolean;
  click?: () => void;
}

@Component({
  selector: 'simple-dialog',
  templateUrl: 'simple-dialog.component.html',
  imports: [MatButtonModule, MatDialogModule, MatIconModule, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleDialog extends PuebloBase {
  private readonly dialogRef = inject(MatDialogRef);

  readonly title = input<string>('');
  readonly contentStr = input<string>('');
  readonly contentTmpl = input<TemplateRef<any> | undefined>();
  readonly leftAction = input<SimpleDialogButtonConfig | undefined>({
    type: 'default',
    label: 'Cancel',
    close: true,
    error: true,
  });
  readonly rightAction = input<SimpleDialogButtonConfig | undefined>({
    type: 'flat',
    label: 'Confirm',
    close: true,
  });

  protected handleLeftActionClicked() {
    const actionFn = this.leftAction()?.click;
    if (actionFn) actionFn();
    if (this.leftAction()?.close) this.dialogRef.close();
  }

  protected handleRightActionClicked() {
    const actionFn = this.rightAction()?.click;
    if (this.rightAction()?.close) this.dialogRef.close();
    if (actionFn) actionFn();
    if (this.rightAction()?.back) {
      this.pbRouter.goBack();
    }
  }

  ngOnInit() {
    if (this.contentStr() && this.contentTmpl()) {
      throw new Error('SimpleDialog: contentStr and contentTmpl are exclusive');
    }
  }
}
